import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "item"
};
const _hoisted_3 = {
  class: "item"
};
export function render(_ctx, _cache) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/",
    class: "nav-item",
    "active-class": "nav-color"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      class: "icon",
      name: "apps-o",
      size: "0.8rem"
    }), _cache[0] || (_cache[0] = _createTextVNode("功能页 "))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: "/mine",
    "active-class": "nav-color",
    class: "nav-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      class: "icon",
      name: "wap-home-o",
      size: "0.8rem"
    }), _cache[1] || (_cache[1] = _createTextVNode("我的 "))]),
    _: 1
  })])]);
}